/* eslint-disable sort-exports/sort-exports */
// Time constants (in milliseconds)
export const FILE_DELETE_REFRESH_TIMEOUT = 1500; // 2.5 seconds
export const FILE_DELETE_TIMEOUT = 6000; // 6 seconds
export const SPECTRE_TOKEN_REFRESH_INTERVAL = 8 * 60 * 1000; // 8 minutes
export const TOKEN_REFRESH_INTERVAL = 40 * 60 * 1000; // 40 minutes
export const UPLOAD_COMPLETE_TIMEOUT = 2500; // 1.5 seconds
export const VERIFICATION_CHECK_INTERVAL = 8000; // 8 seconds

// File size limits
export const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024 * 1024; // 100 GB
export const MAX_ON_PREM_FILE_SIZE = 46 * 1024 * 1024 * 1024; // 46 GB

// Local storage keys
export const LS_FILE_UPLOAD_STATUS = 'isAnyFileBeingUploaded';

// Error messages
export const ERROR_MESSAGES = {
    FILE_NOT_AVAILABLE: 'Original file not available for resuming upload',
    MISSING_FILE_INFO: 'Missing required file information for resuming upload',
    PREPARE_UPLOAD_FAILED: 'Failed to prepare file for upload:',
    RESUME_UPLOAD_FAILED: 'Failed to resume upload:',
    UPLOAD_SESSION_FAILED: 'Failed to start upload session:'
};

// File states
export const FILE_STATES = {
    DELETING: 'deleting',
    ERROR: 'error',
    QUEUED: 'queued',
    UPLOADING: 'uploading',
    VERIFYING: 'verifying'
};
